import {EventEmitter} from 'events';
import {useEffect} from "react";

class EventBus extends EventEmitter {
    private static instance: EventBus;

    private constructor() {
        super();
    }

    public static getInstance(): EventBus {
        if (!EventBus.instance) {
            EventBus.instance = new EventBus();
        }
        return EventBus.instance;
    }
}

export default EventBus.getInstance();

export const EventTypes = {
    SCHEDULE_DELETE: 'schedule_delete',
    PAGE_CLEAR: 'page_clear',
};
